module.exports = "<h2 id=jpex>Jpex</h2> <p><a href=/api/extend>extend</a></p> <p><a href=/api/register>register</a></p> <p><a href=/api/use>use</a></p> <p><a href=/api/resolve>$resolve</a></p> <p><a href=/api/clearCache>$clearCache</a></p> <p><a href=/api/trigger>$trigger</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/content/api/jpex.md
// module id = 37
// module chunks = 0